import React, { useState } from "react";

import DocumentRow from "../../DocumentRow/DocumentRow";
import PanelActionBarComponent from "../../common/PanelActionBarComponent";
import GenrateDocument from "../../GenrateDocument/GenrateDocument";
import ContactPanelForTreatment from "../../TreatmentPage/components/ContactPanelForTreatment";
import InformationPanel from "../../common/InformationPanel";
import VerifiedIcon from "../../../assets/verified_yes.png";
import NonVerifiedIcon from "../../../assets/verifiedno.png";
import TreatmentNotesSection from "../../TreatmentPage/NotesTreatmentSection";
import { formatCalendarDate } from "../../../Utils/helper";
import "../../common/RecordPanel.css";

function WitnessSimpleView({ witnesses = [], onEditWitness }) {
  const [showDocument, setShowDocument] = useState(false);
  const [instanceIdForGenrateDoc, setInstanceIdForGenragteDoc] = useState(null);
  const [dropdownName, setDropdownName] = useState(null);
  const handleGenrateDocument = (instanceId, name) => {
    setInstanceIdForGenragteDoc(instanceId);
    setDropdownName(name);
    setShowDocument(true);
  };

  const WitnessButtonsConfig = [
    {
      id: "generate-document-button",
      iconClassName: "ic ic-15 ic-generate-document",
      buttonText: "Letter",
      className: "p-l-6 p-r-5",
      style: { height: "25px" },
      onClick: handleGenrateDocument,
    },
  ];
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const WitnessBtnConfig2 = [
    {
      id: "generate-document-button",
      iconClassName: "ic ic-19 ic-avatar has-avatar-icon has-cover-img m-l-5",
      imgSrc: hoveredIndex ? VerifiedIcon : NonVerifiedIcon,

      imgClassName: "ic ic-19 m-r-5",
      buttonText: "9/20/25 10:30 AM",
      className: "p-l-6 p-r-5",
      style: { height: "25px" },
      onHover: () => {
        setHoveredIndex(true);
      },
      onMouseLeave: () => {
        setHoveredIndex(null);
      },
      onClick: () => {
        setHoveredIndex(true);
      },
    },
  ];
  const getPartyIcon = (partyType) => {
    switch (partyType?.toLowerCase()) {
      case "client":
        return <i className="ic ic-15 ic-client m-r-5" />;
      case "defendant":
        return <i className="ic ic-15 ic-defendants m-r-5" />;
      case "other party":
        return <i className="ic ic-15 ic-parties m-r-5" />;
      default:
        return <i className="ic ic-15 ic-parties m-r-5" />;
    }
  };
  return (
    <>
      {witnesses &&
        witnesses.map((object) => {
          const firstName = object?.witness_first_name?.trim() || "";
          const lastName = object?.witness_last_name?.trim() || "";
          const name = `${firstName} ${lastName}`.trim();
          const type = (
            <div className="d-flex align-items-center" style={{ fontWeight: "600" }}>
              {getPartyIcon(object.witness_for_entity)}
              <span className="text-truncate">{object.witness_for_name || ""}</span>
            </div>
          );
          return (
            <div className="report record-panel" key={object?.id}>
              <PanelActionBarComponent
                compact
                id={object?.id}
                title={object?.witness_title}
                object={object}
                page_id={10}
                panelIconSrc="https://simplefirm-bucket.s3.amazonaws.com/static/BP_resources/images/icon/witnesses-icon-color.svg"
                name={`${object?.witness_first_name ?? ""} ${object?.witness_last_name ?? ""}`}
                type={type}
              />

              {/* Witness contact block */}
              <div
                className="flex-row d-flex record-panel-body flex-wrap"
                style={{ overflow: "hidden" }}
              >
                <div className="d-flex flex-wrap" style={{ gap: "5px" }}>
                  {/* Witness Contact */}
                  <div className="min-w-260px-client">
                    <ContactPanelForTreatment
                      id={object?.id}
                      panel_name="Witness Contact"
                      className="m-b-0"
                      pageName={"treatment"}
                      name={name}
                      address1={object?.witness_contact_home?.address1}
                      address2={object?.witness_contact_home?.address2}
                      city={object?.witness_contact_home?.city}
                      state={object?.witness_contact_home?.state}
                      zip_code={object?.witness_contact_home?.zip}
                      phone_number={object?.witness_contact_home?.phone_number}
                      ext={object?.witness_contact_home?.phone_ext}
                      fax_number={object?.witness_contact_home?.fax}
                      email={object?.witness_contact_home?.email}
                      websiteUrl={object?.witness_contact_home?.website}
                      buttonData={WitnessButtonsConfig}
                      // genrate_doc_address={"Witness Address"}
                      genrate_doc_address={16}
                      templateDropdownId={16}
                      templatePageId={10}
                      onSelectObject={() => onEditWitness?.(object)}
                    />
                  </div>

                  {/* Information Block */}
                  <div className="min-w-260px-client">
                    <InformationPanel
                      panel_name={"Information"}
                      className=""
                      pageName="WitnessSimple"
                      data={[
                        {
                          label: "Named By",
                          value: object?.witness_for_name,
                        },
                        {
                          label: "Birthday",
                          value: formatCalendarDate(object?.witness_birthday),
                        },
                        {
                          label: "Gender",
                          value: object?.witness_gender,
                        },
                      ]}
                      onSelectReport={() => onEditWitness?.(object)}
                      hasBtn={true}
                      defaultLength={5}
                      buttonData={WitnessBtnConfig2}
                    />
                  </div>
                </div>

                {/* Notes Section */}
                <div
                  className=""
                  style={{
                    flex: 1,
                    minHeight: "155px",
                    paddingRight: "0px",
                    scrollbarWidth: "none",
                    minWidth: "min(400px, 100%)",
                  }}
                >
                  <p className="menu-bar-style columnsTitle text-center">Notes</p>
                  <TreatmentNotesSection
                    entity_type={"Witnesses"}
                    record_id={object?.id}
                    module={"Witnesses"}
                    pagePanels={2}
                  />
                </div>
              </div>

              {/* Document Row */}
              <div className="documents-wrapper m-t-5">
                <div className="col-12">
                  {/* <div className="height-25">
                    <h4 className="text-capitalize d-flex align-items-center justify-content-center h-100 text-lg text-upper-case background-main-10 font-weight-semibold text-center client-contact-title">
                      &nbsp;Document Row
                    </h4>
                  </div> */}
                  <DocumentRow clientProvider={object} page_id={10} showSaveToPage={false} />
                </div>
              </div>
            </div>
          );
        })}

      {showDocument && (
        <GenrateDocument
          show={true}
          handleClose={() => setShowDocument(false)}
          PageEntity="Witnesses"
          instanceId={instanceIdForGenrateDoc}
          dropdownName={dropdownName}
        />
      )}
    </>
  );
}

export default React.memo(WitnessSimpleView);
